import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TextLoca } from "../../generic/text/TextLoca";
export var CoopPointsToCollect = function (_a) {
    var totalPoints = _a.totalPoints;
    return (React.createElement("div", null,
        React.createElement("div", { className: "flex flex--stacked flex--guts" },
            React.createElement("div", { className: "coop-help-points-divider" }),
            React.createElement("div", { className: "coop-help-points-divider" })),
        React.createElement("div", { className: IdStyles.TableRowCoopHelp + " tr" },
            React.createElement("div", { className: "td td--coop-loyalty-name" },
                React.createElement(TextLoca, { id: IdLoca.coopHelp_availablePoints })),
            React.createElement("div", { className: "td__divider" }),
            React.createElement("div", { className: "td" },
                React.createElement(NumberFormat, { amount: totalPoints || 0 })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/help/CoopPointsToCollect.tsx
// module id = 2604
// module chunks = 3